import { env } from '@/env';
import { getSessionValues } from '@/providers/session-provider/get-session-values';
import type { SessionValues } from '@/providers/session-provider/types';

export type GetAuthHeadersParams = {
  session?: SessionValues;
};

export function getAuthHeaders(args?: GetAuthHeadersParams) {
  const session = args?.session ?? getSessionValues();

  const headers = new Headers({
    Authorization: `Token ${session.token}`,
    'X-PIGELLO-CUSTOMER-ID': session.customerId,
    'X-PIGELLO-CLIENT-TYPE': `${env.NEXT_PUBLIC_CLIENT_TYPE},frontend,1.0.0`,
    'X-PIGELLO-USER-ID': session.userId,
    ...(session.segments.length > 0 && {
      'X-PIGELLO-CHOSEN-SEGMENT': session.segments.join(','),
    }),
  });

  return headers;
}
